<template>
  <v-app-bar
    app
    class="header mb-0 pb-0"
    color="primary"
    :height="$vuetify.breakpoint.smAndDown ? 40 : 110"
    elevation="2"
  >
    <ticker-tape v-if="$vuetify.breakpoint.mdAndUp" />
    <v-container
      class="d-flex flex-direction-row justify-space-between align-center align-md-end container"
    >
      <div class="toolbar--container d-flex align-center justify-space-between">
        <!-- LOGO -->
        <div class="d-flex align-center">
          <router-link to="/">
            <picture>
              <source
                :srcset="desktopLogo"
                media="(min-width: 960px)"
              />
              <img
                :src="mobileLogo"
                :alt="altLogo"
                :width="$vuetify.breakpoint.mdAndUp ? 220 : 110"
                class="logo"
              />
            </picture>
          </router-link>
        </div>
        <!-- MENU HAMBURGER -->
        <v-app-bar-nav-icon
          @click.stop="toggleDrawer"
          class="hidden-md-and-up"
          color="white"
        />
        <v-spacer class="hidden-sm-and-down" />
        <app-menu />
      </div>
    </v-container>
  </v-app-bar>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import AppMenu from './AppMenu'
import TickerTape from '../widgets/TickerTape.vue'

export default {
  components: {
    AppMenu,
    TickerTape
  },
  name: 'AppToolBar',
  data() {
    return {
      notifications: [],
      item: 1
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('setting', ['whiteBranding']),
    heightNavbar() {
      return this.$vuetify.breakpoint.smAndDown ? 40 : 120
    },

    desktopLogo() {
      return this.user?.broker && this.whiteBranding ? `data:image/png;base64,${this.user.broker.img_desktop}` : require('@/assets/AV_003_logo_header.svg')
    },

    mobileLogo() {
      return this.user?.broker && this.whiteBranding ? `data:image/png;base64,${this.user.broker.img_mobile}` : require('@/assets/logo-mobile.svg')
    },

    altLogo() {
      return this.user?.broker && this.whiteBranding ? `${this.user.broker.name} Logo` : 'AV Agil Logo'
    }
  },
  methods: {
    ...mapActions(['toggleDrawer']),
    ...mapActions('auth', ['logout']),
    ...mapActions('language', ['setLanguage'])
  },
  created() {
    this.setLanguage('es')
  }
}
</script>
<style lang="sass" scoped>
.toolbar--container
  height: 70px
  width: 100%

header.header
  height: 40px

.container
  padding: 0

.v-sheet.elevation-2
  box-shadow: 0px 6px 10px #0000001A !important

.logo
  max-height: 30px

@media only screen and (min-width: 960px)
  .logo
    max-height: 60px

  header.header
    height: 120px

  .theme--light.v-app-bar.v-toolbar.v-sheet
    height: 120px

  .container
    height: 110px
</style>
